import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function QualityAssuranceServies() {
    const features = [
        {
            title: 'Manual Testing',
            description:
                'Our skilled QA team uses manual testing to ensure your product is of the highest quality, free of bugs. We go beyond traditional methods to evaluate every aspect of your software\'s functionality, leveraging our unsurpassed human intelligence.',
            icon: '/img/technology/ic-manual-testing.svg',
        },
        {
            title: 'Mobile App Testing',
            description:
                'Our Mobility Testing services ensure that your mobile applications deliver superior customer experience to your customers across all mobile devices with high performance and improved time to market.',
            icon: '/img/technology/ic-mobile-app-testing.svg',
        },
        {
            title: 'Web App Testing',
            description:
                'We specialize in ensuring your web applications and e-commerce websites perform flawlessly. Our comprehensive services cover functional testing, compatibility testing, performance testing, security testing, usability testing, and regression testing.',
            icon: '/img/technology/ic-web-app-testing.svg',
        },
        {
            title: 'UI/UX Testing',
            description:
                'We use our expertise in understanding your target audience\'s requirements and expectations to select the right participants for your UI/UX testing. Our team helps to create a smooth and valuable UX for your software, making sure that its UI logic works for all categories of users.',
            icon: '/img/technology/ic-ui-ux-testing.svg',
        },
        {
            title: 'API Testing',
            description:
                'We leverage API testing services to ensure the correct operation of all your application programming interfaces (APIs) by validating their functionality, performance, security, as well as reliability.',
            icon: '/img/technology/ic_api-testing.svg',
        },
        {
            title: 'Code Verification',
            description:
                'Code verification identifies and fixes software bugs and performance issues early, reducing development time and time to market. We offer a wide range of testing and QA services to ensure bug-free code with excellent performance.',
            icon: '/img/technology/ic-coding-testing.svg',
        },
        {
            title: 'Load & Performance Testing',
            description:
                'We test software performance under specific workloads to evaluate how it will behave in real-world conditions. Our services help clients overcome business challenges and improve application performance, resulting in a future-proofed system of superior quality.',
            icon: '/img/technology/ic-performance-testing.svg',
        },
        {
            title: 'Security Testing & Vulnerability Assessment',
            description:
                'Our application security testing services validate your entire system to eliminate risk and vulnerabilities, delivering trust. Our professionals stay up to date on the latest security practices and threats to ensure the high security of your software.',
            icon: '/img/technology/ic-security-testing.svg',
        },
        {
            title: 'Automation Testing',
            description:
                'Our QA team leverages its test automation expertise and the latest tools and frameworks to accelerate testing cycles, enhance test coverage, and deliver faster, error-free releases, optimizing your development process.',
            icon: '/img/technology/ic-automation-testing.svg',
        },
    ];

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                Quality Assurance Services
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid features={features} variant="grey" />
                </div>
            </div>
        </>
    );
}

export default QualityAssuranceServies;